import { isNotebookOwner } from '../../utils/notebookOwnership';

/** Aggregates for Learn hub hero metrics (from GET /api/v1/learn/notebooks). */
export function computeLearnHubStats(notebooks, viewer = null) {
  const list = Array.isArray(notebooks) ? notebooks : [];

  const totalQuestions = list.reduce((sum, nb) => sum + (Number(nb.questionCount) || 0), 0);
  const withProgress = list.filter((nb) => typeof nb.progressPercent === 'number');
  const avgProgress = withProgress.length
    ? Math.round(withProgress.reduce((s, nb) => s + nb.progressPercent, 0) / withProgress.length)
    : 0;

  const isPublicVisibility = (visibility) => {
    const v = (visibility || 'PRIVATE').toUpperCase();
    return v === 'PUBLIC' || v === 'TEAM' || v === 'UNLISTED';
  };

  return {
    createdByYou: viewer
      ? list.filter((nb) => isNotebookOwner(nb, viewer)).length
      : list.filter((nb) => nb.ownedByMe === true).length,
    publicShared: list.filter((nb) => isPublicVisibility(nb.visibility)).length,
    privateNotebooks: list.filter((nb) => !isPublicVisibility(nb.visibility)).length,
    withQuestions: list.filter((nb) => (Number(nb.questionCount) || 0) > 0).length,
    totalQuestions,
    inProgress: list.filter((nb) => {
      const p = nb.progressPercent;
      return typeof p === 'number' && p > 0 && p < 100;
    }).length,
    avgProgress,
  };
}
